'use client'

import { IS_PROD } from '@/core/constants/is-prod'
import { PROVIDER_ROUTES } from '@/core/constants/routes'
import { envService } from '@/core/services/env'
import { useCookiesStore } from '@/core/store/cookies'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { usePathname } from 'next/navigation'
import Script from 'next/script'

export const FacebookPixel = () => {
  const pathname = usePathname()
  const isProvider = pathname?.includes(PROVIDER_ROUTES.base)
  const pixelId = isProvider
    ? envService.get('PROVIDER_PIXEL_ID')
    : envService.get('CUSTOMER_PIXEL_ID')

  const { cookiesConsented } = useCookiesStore()
  if (!pixelId || !IS_PROD || !cookiesConsented) return null

  return (
    <>
      <Script
        id={`fb-pixel-${isProvider ? AccountType.PROVIDER : AccountType.CUSTOMER}`}
        strategy='lazyOnload'
        rel='preconnect'
        crossOrigin='anonymous'
        dangerouslySetInnerHTML={{
          __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
        `,
        }}
      />

      <noscript
        dangerouslySetInnerHTML={{
          __html: ` <img
          height='1'
          width='1'
          style='display:none;'
          src={'https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1'}
          alt=''
        />`,
        }}
      ></noscript>
    </>
  )
}
